export abstract class SiteTrendModel {
    MeasurementDt : Date;

    constructor(measurementDt : Date)
    {
        this.MeasurementDt = measurementDt;
    }
}